<div
  class="w-full flex justify-center border-t border-gray-200 shadow-sm bg-gray-100"
>
  <div class="nav-menu-wrapper w-[80vw] flex justify-start">
    <nav
      class="flex text-sm font-semibold text-gray-700 w-[80%] justify-between"
    >
      <span class="border-l border-gray-300 h-14"></span>
      <a
        routerLink="/home"
        routerLinkActive="text-green-600 border-b-2 border-green-600"
        class="py-4 relative hover:text-green-600"
        >HOME</a
      >
      <span class="border-l border-gray-300 h-14"></span>
      <a
        routerLink="/resource"
        routerLinkActive="text-green-600 border-b-2 border-green-600"
        class="py-4 hover:text-green-600"
        >INDEX RESOURCES</a
      >
      <span class="border-l border-gray-300 h-14"></span>
      <a
        href="https://brio.smartderivatives.com/qis"
        appExternalLink="https://brio.smartderivatives.com/qis"
        target="_blank"
        rel="noopener noreferrer"
        class="py-4 relative hover:text-green-600 flex brio-nav-item"
        >brio <sup>TM</sup> <i class="pi pi-lock"></i
      ></a>
      <span class="border-l border-gray-300 h-14"></span>
      <a
        routerLink="/about"
        routerLinkActive="text-green-600 border-b-2 border-green-600"
        class="py-4 relative hover:text-green-600"
        >ABOUT US</a
      >
      <span class="border-l border-gray-300 h-14"></span>
      <a
        routerLink="/contact"
        routerLinkActive="text-green-600 border-b-2 border-green-600"
        class="py-4 relative hover:text-green-600"
        >CONTACT US</a
      >
      <span class="border-l border-gray-300 h-14"></span>
    </nav>
  </div>
</div>
